import { classes } from '../const';

const { isOpen } = classes;

const dropdownLinks = () => {
  const $$dropdownLinks = $('.menu-link.menu-link_dropdown');
  $$dropdownLinks.each((i, el) => {
    $(el).hover(() => {
      $(el).parents(".header").addClass("mega-menu-open");
    }, () => {
      $(el).parents(".header").removeClass("mega-menu-open");
    });
    $(el).click(event => {
      if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

      if ($(event.target).closest('.menu-dropdown__link').length) return;

      event.preventDefault();

      $$dropdownLinks.each((j, link) => {

        if (link === el) {
          $(el).toggleClass(isOpen);
        } else {
          $(link).removeClass(isOpen);
        }
      });
    });

    $(document).click(event => {
      if (!$(event.target).closest(el).length) {
        $(el).removeClass(isOpen);
      }
    });
  });
};

export default dropdownLinks;
